import Select from 'react-select'
import * as React from 'react'
import * as moment from 'moment'
import PreloaderCircle from '../ui/PreloaderCircle'
import DashboardItem from './DashboardItem'
import { IRecentTripObj, ITripFilters, IRiderTrip, IPagination, IRiderObject } from '../../types'
import history from '../../history'
import { TripStatuses } from '../../constants/trip-statuses'
import UIMessages from 'src/utils/ui-messages'
interface IControlsProps {
  filters: ITripFilters
  onChange: (filters: ITripFilters) => Promise<any>
  onGroupScheduledTrips: () => Promise<any>
}
interface IControlsState {}

const options = [
  { label: 'All Active', value: 'ACTIVE' },
  { label: 'Flex Return', value: TripStatuses.WILL_CALL },
  { label: 'Expired', value: TripStatuses.EXPIRED },
  { label: 'Scheduled', value: TripStatuses.SCHEDULED },
  { label: 'Schedule Requested', value: TripStatuses.SCHEDULE_REQUESTED },
  { label: 'Schedule Accepted', value: TripStatuses.SCHEDULE_ACCEPTED },
  { label: 'Cancelled', value: TripStatuses.CANCELLED },
  { label: 'Driver Cancelled', value: TripStatuses.DRIVER_CANCELLED },
  { label: 'Cancelled Billable', value: TripStatuses.CANCEL_BILLABLE },
  { label: 'No Show Rider', value: TripStatuses.NO_SHOW_RIDER },
  { label: 'Requesting', value: TripStatuses.REQUESTED },
  { label: 'Waiting', value: TripStatuses.WAITING },
  { label: 'Driving to pickup', value: TripStatuses.TO_PICK_UP },
  { label: 'Driving to drop off', value: TripStatuses.TO_DROP_OFF },
  { label: 'Waiting for pickup', value: TripStatuses.ACCEPTED },
  { label: 'En Route', value: TripStatuses.PICKED_UP },
  { label: 'Completed', value: TripStatuses.COMPLETED },
  { label: 'Manually completed', value: TripStatuses.MANUALLY_COMPLETED }
]
class TripDashControls extends React.Component<IControlsProps, IControlsState> {
  public render() {
    const filters = this.props.filters
    const selectedOption = options.find(o => o.value === (filters.status || [])[0]) || options[0]
    const styles = {
      control: (provided: any, state: any) => {
        return {
          cursor: 'pointer',
          display: 'flex',
          minHeight: '38px',
          borderWidth: '1px',
          borderBottom: '1px solid',
          borderColor: '#137CBD'
        }
      },
      singleValue: (provided: any, state: any) => ({
        ...provided,
        color: '#137CBD'
      }),
      dropdownIndicator: (provided: any, state: any) => ({
        ...provided,
        color: '#137CBD'
      }),
      indicatorSeparator: (provided: any, state: any) => ({
        width: 0
      })
    }
    return (
      <div className='flex justify-between'>
        <div className='select-control-container mb1 custom-select' style={{ width: '130px' }}>
          <Select
            styles={styles}
            classNamePrefix='select-control'
            isSearchable={false}
            options={options}
            value={selectedOption}
            onChange={this.changeStatus}
          />
        </div>
        {this.props.filters.serviceId && (
          <button
            type='submit'
            className='btn-sm bg-red rounded font-white weight-300'
            onClick={this.props.onGroupScheduledTrips}
          >
            {UIMessages.common.group}
          </button>
        )}
      </div>
    )
  }

  private changeStatus = (option: any) => {
    if (option) {
      const status = ['ACTIVE'].includes(option.value) ? undefined : [option.value]
      let statusGroup

      if (option.value === 'ACTIVE') {
        statusGroup = 'all'
      }
      this.props.onChange({ status, statusGroup })
    }
  }
}

interface ITripsDashboardProps {
  orgId: string
  showOrgServiceArea: () => void
  updateTripFilters: (filters: ITripFilters) => Promise<any>
  fetchRiders: () => Promise<any>
  fetchTrips: (filters: ITripFilters, pagination?: IPagination) => Promise<any>
  getRiderPersonalInfo: (riderId: string) => void
  cloneTrip: (trip: IRiderTrip) => Promise<any>
  onGroupScheduledTrips: (param: ITripFilters) => Promise<any>
  trips: IRecentTripObj
  riders: { [key: number]: IRiderObject }
  tripFilters: ITripFilters
  isFetching: boolean
  StatGroup: ITripFilters
}

interface ITripsDashboardState {
  pageIndex: number
  pages: number
  loadingTrips: boolean
  isAwayFromBrowserTab: boolean
}

const PAGE_SIZE = 50
const INTERVAL = 20000

class TripsDashboard extends React.Component<ITripsDashboardProps, ITripsDashboardState> {
  public resetTripFilter: boolean
  private intervalId: ReturnType<typeof setInterval>

  constructor(props: ITripsDashboardProps) {
    super(props)
    this.state = {
      pageIndex: 0,
      pages: 1,
      loadingTrips: true,
      isAwayFromBrowserTab: false
    }
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this)
  }

  public async componentDidMount() {
    await this.tripsFilterReset()
    await this.getData()
    if (this.intervalId === undefined) {
      clearInterval(this.intervalId)
      this.intervalId = setInterval(this.getData, INTERVAL)
    } else {
      clearInterval(this.intervalId)
      this.intervalId = setInterval(this.getData, INTERVAL)
    }
    this.resetTripFilter = true
    this.setState({
      loadingTrips: false
    })
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  }

  public componentWillMount() {
    this.props.showOrgServiceArea()
  }

  public async componentWillUnmount() {
    const newFilter: ITripFilters = {
      orgId: this.props.orgId,
      productIds: undefined,
      serviceIds: this.props.tripFilters.serviceIds,
      serviceId: this.props.tripFilters.serviceId,
      status: undefined,
      statusGroup: undefined,
      timeField: undefined,
      timeStart: undefined,
      timeEnd: undefined,
      sortBy: []
    }

    clearInterval(this.intervalId)

    if (this.resetTripFilter && !this.nextRouteIs('/scheduler', history)) {
      await this.props.updateTripFilters(newFilter)
    }
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  }

  public handleVisibilityChange() {
    if (document.hidden) {
      this.setState(prevState => ({
        ...prevState,
        isAwayFromBrowserTab: true
      }))
    } else {
      this.setState(prevState => ({
        ...prevState,
        isAwayFromBrowserTab: false
      }))
    }
  }

  public nextRouteIs(nextRoute: string, history: { location: { pathname: string } }) {
    return history && nextRoute === history.location.pathname
  }
  public async componentDidUpdate(prevProps: ITripsDashboardProps) {
    const { tripFilters } = this.props

    if (JSON.stringify(prevProps.tripFilters) !== JSON.stringify(tripFilters)) {
      this.getData()
    }
  }

  public render() {
    const { tripFilters } = this.props
    const { pageIndex, pages } = this.state
    const canNext = pages > 1 && pageIndex + 1 < pages
    const canPrevious = pages > 1 && pageIndex + 1 > 1

    const styles = {
      CirclePreLoader: {
        display: 'flex',
        paddingTop: '5px',
        flex: 1,
        justifyContent: 'center',
        alignment: 'center',
        width: '100%'
      }
    }

    if (this.state.loadingTrips) {
      return (
        <div style={styles.CirclePreLoader}>
          <PreloaderCircle loading={true} />
        </div>
      )
    }

    if (!Object.keys(this.props.trips).length) {
      return (
        <div className='pt1 pb2 px3'>
          <TripDashControls
            filters={tripFilters}
            onChange={this.props.updateTripFilters}
            onGroupScheduledTrips={() =>
              this.props.onGroupScheduledTrips({ orgId: this.props.orgId, serviceId: this.props.tripFilters.serviceId })
            }
          />
          <div className='center'>
            <p className=''>No Trips</p>
          </div>
        </div>
      )
    }
    const trips = Object.values(this.props.trips)
    const riders = Object.values(this.props.riders)

    return (
      <React.Fragment>
        <div className='pt1 pb2 px1' style={{ height: 'calc(100% - 7rem)', overflowY: 'scroll' }}>
          {/* <div className='pt1 pb2 px1' style={{ height: 'calc(100% - 12rem)', overflowY: 'scroll'}}> */}
          <TripDashControls
            filters={tripFilters}
            onChange={this.props.updateTripFilters}
            onGroupScheduledTrips={() =>
              this.props.onGroupScheduledTrips({ orgId: this.props.orgId, serviceId: this.props.tripFilters.serviceId })
            }
          />
          <div className='col-12 m0'>
            {/* previous condition from filter is all trips are being returned here last condtion is !!item from callback */}
            {trips &&
              trips
                .filter((item: IRecentTripObj) =>
                  this.props.tripFilters.serviceId
                    ? this.props.tripFilters.serviceId === item.service.serviceId
                    : !!item
                )
                .map((item: IRecentTripObj) => {
                  const matchingRider = riders.find(rider => {
                    return rider.id === item.rider.riderId
                  })

                  return (
                    <DashboardItem
                      key={item.id}
                      trip={item}
                      cloneTrip={this.copyTrip(item)}
                      filters={tripFilters}
                      isArchived={matchingRider ? true : false}
                    />
                  )
                })}

            {/* View More after the rider list  */}
            <div className='col-12 bg-white pt3' style={{ height: '2rem' }}>
              <div className='text-center cursor--pointer ' onClick={this.viewMoreTrips}>
                View More
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }

  private tripsFilterReset = async () => {
    const defaultTimeStart = moment()
      .startOf('day')
      .toISOString()
    const defaultTimeEnd = moment()
      .endOf('day')
      .toISOString()
    const {
      serviceId = '',
      serviceIds = [],
      timeStart = defaultTimeStart,
      timeEnd = defaultTimeEnd
    } = this.props.tripFilters
    await this.props.updateTripFilters({
      status: undefined,
      riderId: undefined,
      productIds: undefined,
      operatorId: undefined,
      timeField: undefined,
      serviceIds,
      serviceId,
      timeStart,
      timeEnd
    })
  }

  private getData = async () => {
    if (this.state.isAwayFromBrowserTab) {
      console.log('The page is not visible, the user might be away. refreshing trips will not be executed.')
      return
    }
    // Prevent trips from being refreshed when on other components (Timeline view, etc.)
    if (history.location.pathname !== '/' && history.location.pathname !== '/trips') {
      return
    }
    console.log('Refreshing trips...')
    let pagination = { skip: this.state.pageIndex * PAGE_SIZE, take: PAGE_SIZE }
    const { tripFilters } = this.props
    let filters =
      !tripFilters.status && !tripFilters.statusGroup ? { ...tripFilters, statusGroup: 'active' } : { ...tripFilters }

    if (filters.statusGroup === 'active' && !filters.getDashBoardData) {
      filters = {
        ...filters,
        timeField: 'tripCreated',
        sortBy: ['lastStatus-desc'],
        timeStart: moment()
          .subtract(72, 'hours')
          .toISOString(),
        timeEnd: moment().toISOString()
      }
      pagination = { skip: 0, take: 100 }
    } else if (filters.statusGroup === 'scheduled' && !filters.getDashBoardData) {
      filters = {
        ...filters,
        timeField: 'pickup',
        timeStart: moment()
          .subtract(8, 'hours')
          .toISOString(),
        timeEnd: moment()
          .add(8, 'hours')
          .toISOString(),
        sortBy: ['scheduledPickupTime-asc']
      }
    } else if (filters.getDashBoardData === true) {
      filters = {
        ...filters,
        timeField: tripFilters.timeField,
        timeStart: tripFilters.timeStart,
        timeEnd: tripFilters.timeEnd,
        sortBy: tripFilters.sortBy
      }
    } else {
      filters = {
        ...filters,
        timeField: undefined,
        timeStart: undefined,
        timeEnd: undefined,
        sortBy: ['created-desc']
      }
    }

    const total = await this.props.fetchTrips(filters, pagination)
    await this.props.fetchRiders()

    this.setState({
      pages: Math.ceil(total / PAGE_SIZE)
    })
  }

  private copyTrip = (trip: IRecentTripObj) => (e: any) => {
    this.props.cloneTrip(trip)
  }

  private viewMoreTrips = () => {
    const { tripFilters } = this.props
    const filters =
      !tripFilters.status && !tripFilters.statusGroup ? { ...tripFilters, statusGroup: 'active' } : tripFilters
    console.log('filters: ', filters)
    this.props.updateTripFilters(filters)
    this.resetTripFilter = false
    history.push('/trips-management')
  }

  private nextPage = () => {
    const pageIndex = this.state.pageIndex + 1
    const pagination = { skip: pageIndex * PAGE_SIZE, take: PAGE_SIZE }
    this.props.fetchTrips(this.props.tripFilters, pagination)
    this.setState({
      pageIndex
    })
  }

  private previousPage = () => {
    const pageIndex = this.state.pageIndex - 1
    const pagination = { skip: pageIndex * PAGE_SIZE, take: PAGE_SIZE }
    this.props.fetchTrips(this.props.tripFilters, pagination)
    this.setState({
      pageIndex
    })
  }
}

export default TripsDashboard



// WEBPACK FOOTER //
// ./src/components/trips/TripsDashboard.tsx